import deepFind from '../../../functions/deepFind';

export const checkIfStateValueIsTrue = (state, condition) => {
  const { ifId } = condition;

  return deepFind(state, ifId);
};
